import { useCallback } from 'react';
import { EKeysMap } from '../../../internal/constants/EKeysMap';
export const useTagOnKeyDown = callback => {
  return useCallback(e => {
    if (e.key === EKeysMap.BACKSPACE || e.key === EKeysMap.DELETE) {
      callback();
    }
  }, [callback]);
};